import React, { useContext, useEffect, useState } from 'react';
import styles from './index.module.scss';
import clsx from 'clsx';
import { CloseButton } from './CloseButton';
import { toJSX } from 'src/utils/toJSXHelper';
import { I18nContext } from 'src/stores/I18n';
import { useRouter } from 'next/router';
import { LOCALE_TYPE } from 'src/types/locale';
import { mixpanel } from 'src/utils/mixpanel';
import {
  generateQuestionnaireURL,
  questionnairePopupDisplayedPage,
} from 'src/components/shared/templates/questionnaire/utils';
import { useResponsive } from 'src/hooks/useResponsive';

type Props = {
  timeoutMS?: number;
};

export const QuestionnairePopup: React.FC<Props> = ({ timeoutMS = 60000 }) => {
  const [isVisible, setIsVisible] = useState(false);
  const { locale, asPath, pathname } = useRouter();
  const { isDesktop } = useResponsive();
  const shouldDisplayPopup = questionnairePopupDisplayedPage.some((page) => pathname.includes(page));
  const questionnaireLink = generateQuestionnaireURL(locale as LOCALE_TYPE);
  const localeResources = useContext(I18nContext);
  const handleClose = () => setIsVisible(false);
  const handleClick = (): void => mixpanel.onQuestionnaireLinkClicked('popup', asPath);

  useEffect(() => {
    const timeout = setTimeout(() => setIsVisible(true), timeoutMS);
    return () => clearTimeout(timeout);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!shouldDisplayPopup || !isVisible || isDesktop) return null;

  return (
    <div className={styles.container}>
      <CloseButton onClick={handleClose} />
      <div className={clsx(styles.contentContainer)}>
        <p>{toJSX(localeResources.questionnaire.popup(questionnaireLink, styles.link), handleClick)}</p>
      </div>
    </div>
  );
};
